// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3gKA6","error":"Textarea_error__cgrxm","readonly":"Textarea_readonly__3Wlcq","disabled":"Textarea_disabled__22TQI"};